const raw = process.env.REACT_APP_PRICING_ALLOWED_EMAILS ?? "";
const allowedEmails = raw.split(",").map((e) => e.trim().toLowerCase()).filter(Boolean);

// If the env var is unset/empty → subscriptions are open to everyone.
// If the env var is set → only the listed emails can subscribe (allowlist mode).
export const allowlistActive = allowedEmails.length > 0;

export const pricingSubscriptionsEnabled = true; // page is always visible

export function canUserSubscribe(email) {
  if (!allowlistActive) return true; // open to all
  if (!email) return false;
  return allowedEmails.includes(email.trim().toLowerCase());
}
